import {
  formatShopMoney,
  getShopMoneyFormatOptions,
} from "../../shared/format-shop-money.js";

function readConfigShopMoney() {
  if (typeof window === "undefined") return {};
  const cfg = window.weupsellConfig || {};
  const embeddedShop = cfg.popupData?.shop;
  return {
    currency:
      window.Shopify?.currency?.active ||
      embeddedShop?.currency ||
      cfg.currency ||
      null,
      moneyFormat:
      cfg.moneyFormat ||
      embeddedShop?.moneyFormat ||
      embeddedShop?.money_format ||
      cfg.money_format ||
      "",
  };
}

/**
 * Resolve currency + Shopify money template for storefront / preview runtime.
 */
export function resolveStorefrontMoneyOptions(appState) {
  const shop = appState?.shop || {};
  const shopify =
    typeof window !== "undefined" && window.Shopify ? window.Shopify : null;
  const fromConfig = readConfigShopMoney();

  return {
    currency:
    shopify?.currency?.active ||
    fromConfig.currency ||
      shopify?.currency?.currencyCode ||
      shop.currency ||
      "USD",
    moneyFormat:
      fromConfig.moneyFormat ||
      shopify?.money_format ||
      shopify?.moneyFormat ||
      shop.moneyFormat ||
      shop.money_format ||
      "",
  };
}

/** Format a price in major currency units (e.g. dollars, not cents). */
export function formatStorefrontMoney(amountInCurrencyUnits, appState) {
  return formatShopMoney(Number(amountInCurrencyUnits), {
    ...resolveStorefrontMoneyOptions(appState),
  });
}

/** Format a price from Shopify cart/API cents. */
export function formatStorefrontMoneyFromCents(cents, appState) {
  const numericCents = Number(cents);
  if (!Number.isFinite(numericCents)) return "—";
  return formatStorefrontMoney(numericCents / 100, appState);
}

export function formatStorefrontMoneyFromShop(amountInCurrencyUnits, shopData) {
  return formatShopMoney(Number(amountInCurrencyUnits), {
    ...getShopMoneyFormatOptions(shopData || {}),
  });
}
